var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('topbar',{key:_vm.chainstoreKey,attrs:{"storeData":_vm.chainstore}}),_c('storeCardList',{attrs:{"storeGroupId":_vm.chainstore_id}}),_c('mainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }